<template>
  <div class="app-toolbar">
    <el-button-group>
      <el-button
      icon="el-icon-plus"
        type="primary"
        :disabled="!available.create"
        @click="onCreate"
      />
      <el-button
      icon="el-icon-edit"
        type="warning"
        :disabled="!available.update"
        @click="onUpdate"
      />
      <el-button
      icon="el-icon-delete"
        type="danger"
        :disabled="!available.remove"
        @click="$emit('remove')"
      />
      <el-button icon="el-icon-download" @click="$emit('download')" />
    </el-button-group>
    <el-select v-model="type" placeholder="请选择搜索类型">
      <el-option
        v-for="(item, index) in types"
        :key="index"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
    <el-input
      placeholder="请输入搜索内容"
      :value="text"
      clearable
      @input="onInput"
    >
      <el-button slot="append" icon="el-icon-search" @click="onSearch" />
    </el-input>
  </div>
</template>

<script>
export default {
  props: {
    id: String,
    available: {
      type: Object,
      default: () => {
        return {
          create: true,
          update: false,
          remove: false
        };
      }
    },
    value: Object
  },
  data() {
    return {
      type: '',
      types: [
        { label: '业务区', value: 0, prop: 'businessName' },
        { label: '项目名称', value: 1, prop: 'projectName' },
        { label: '进度状态', value: 2, prop: 'progressStatus' },
        { label: '预算', value: 3, prop: 'budget' },
        { label: '项目经理A', value: 4, prop: 'projectManagerA' },
        { label: '项目类型', value: 5, prop: 'projectType' },
        { label: '达产预期', value: 6, prop: 'reachExpect' }
      ],
      text: ''
    };
  },
  methods: {
    async onCreate() {
      await this.$router.push({
        path: 'business/create'
      });
    },
    async onUpdate() {
      await this.$router.push({
        path: 'business/update',
        query: { id: this.id }
      });
    },
    onInput(e) {
      const { type, types } = this;
      let obj = null;
      if (type !== '' && e !== '') {
        const prop = types[type].prop;
        obj = { [`${prop}`]: e };
      }
      this.text = e;
      this.$emit('input', obj);
    },
    async onSearch() {
      this.$emit('search');
    }
  }
};
</script>

<style lang="scss" scoped>
.app-toolbar {
  display: flex;
  margin-bottom: 16px;

  .el-button-group,
  .el-select {
    margin-right: 12px;
  }

  .el-input-group {
    width: 400px;
  }
}
</style>
